<template>
  <div>
    <el-container>
      <el-header>キャンペーン応募ページ</el-header>
      <el-main >
        <el-form ref="CreatePost" :model="postData" label-width="140px">
          <el-form-item label="性">
            <el-col>
              <el-input
                  class="post-input"
                  v-model="postData.lastName"
                  placeholder="例）大日本"
                  autosize
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="名">
            <el-col>
              <el-input
                  class="post-input"
                  v-model="postData.firstName"
                  placeholder="例）太郎"
                  autosize
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="住所">
            <el-col>
              <el-input
                  class="post-input"
                  v-model="postData.address"
                  placeholder="例）東京都新宿区市谷加賀町１−１−１"
                  autosize
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="年齢">
            <el-col>
              <el-input
                  class="post-input"
                  v-model="postData.age"
                  placeholder="例）20"
                  autosize
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="電話番号">
            <el-col>
              <el-input
                  class="post-input"
                  v-model="postData.tel"
                  placeholder="例）03-1234-5678"
                  autosize
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="性別">
            <el-col :span="4">
              <el-select v-model="postData.gender" placeholder="Select">
                <el-option
                  v-for="item in genderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <!--
            <el-col :span="4">
              <el-input
                  class="post-input"
                  v-model="postData.gender"
                  placeholder="例）男"
                  autosize
              ></el-input>
            </el-col>
            -->
          </el-form-item>
          <el-form-item label="応募口数">
            <el-col :span="4">
              <el-select v-model="postData.entries" placeholder="Select">
                <el-option
                  v-for="item in numberOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <!--
            <el-col :span="4">
              <el-input
                  class="post-input"
                  v-model="postData.entries"
                  placeholder="例）2"
                  autosize
              ></el-input>
            </el-col>
            -->
          </el-form-item>
          <el-form-item label="応募シートの写真">
            <el-col :span="10">
              <el-upload 
                  class="upload-demo" 
                  action="" 
                  :on-preview="handlePreview"
                  :on-change="handleAdd"
                  :on-remove="handleRemove" 
                  :before-remove="beforeRemove"
                  multiple
                  :limit="3"
                  :on-exceed="handleExceed"
                  :file-list="fileList" 
                  list-type="picture" 
                  :auto-upload="false">
                  <el-button size="mini" type="default" round>ファイルを選択する</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">jpg/png files with a size less than 500KB</div> -->
              </el-upload>
            </el-col>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="createPost">
          この内容で応募する
        </el-button>
      </el-main>
      <!-- <el-footer>Footer</el-footer> -->
    </el-container>

    <el-dialog
      title="応募受付完了"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <!-- <span>ご応募いただきありがとうございました！</span> -->
      <div style="text-align:center;">ご応募いただきありがとうございました！</div> 
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">Cancel</el-button> -->
        <el-button type="primary" @click="centerDialogVisible = false">閉じる</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { Auth, Storage } from 'aws-amplify';
var uuid = require('uuid');

export default {
  name: "CreatePost",
  data: function() {
    return {
      postData: {
        lastName: "",
        firstName: "",
        address: "",
        age: "",
        tel: "",
        gender: "",
        entries: ""
      },
      fileList: [],
      cognitoId: "",
      genderOptions: [{
        value: '男性',
        label: '男性'
      }, {
        value: '女性',
        label: '女性'
      }, {
        value: 'その他',
        label: 'その他'
      }],
      numberOptions: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }],
      centerDialogVisible: false
    }
  },
  methods: {
    createPost: async function () {
      Auth.currentCredentials()
        .then(d => {
          this.cognitoId = d.identityId;
          console.log('data: ', d);
        })
        .catch(e => console.log('error: ', e));

      if (this.postData.lastName !== '' || this.postData.firstName !== '') {

        var postPath = uuid.v4()+'/';

        for(var i = 0; i < this.fileList.length; i++) {
          Storage.put(postPath+this.fileList[i].name, this.fileList[i].raw, {
            level: 'private',
            contentType: this.fileList[i].type
          })
          .then (result => console.log(result))
          .catch(err => console.log(err));
        }
        
        var blob = new Blob([JSON.stringify(this.postData, null, 2)], {type:'text/plain'});

        Storage.put(postPath+'postData.json', blob, {
          level: 'private',
          contentType: 'text/plain'
        })
        .then (result => console.log(result))
        .catch(err => console.log(err));

        this.postData.lastName = "";
        this.postData.firstName = "";
        this.postData.address = "";
        this.postData.age = "";
        this.postData.tel = "";
        this.postData.gender = "";
        this.postData.entries = "";

        this.fileList = [];

        this.centerDialogVisible = true;
        //this.$router.push(`/complete`)


      } else {
        console.info('input empty')
      }
    },
    // ファイルリストのXボタンを押下した時
    handleRemove: function (file, fileList) {
      this.fileList = fileList
    },
    // ファイルを追加した時
    handleAdd: function (file, fileList) {
      this.fileList = fileList
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfert of ${ file.name } ?`);
    }
  }
};

</script>

<style scoped>
</style>
